import React, { useState } from "react";
import { Modal, CloseButton } from "react-bootstrap";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd/es";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useInvoiceStore } from "./store";

const BulkUploadInVoices = ({tab}) => {
  const [fileData, setFileData] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { setToaster } = useToast();
  const { updateInvoice , updateCredit} = useInvoiceStore();

  function handleShow() {
    setShow(true);
  }

  const beforeUpload = (file) => {
    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      setToaster("File Type", "only csv file allowed", "danger");
      return true;
    }
    return false;
  };

  const uploadFile = () => {
    let file = new FormData();
    file.append("file", fileData);
	if(tab==='invoice'){
    updateInvoice(file, setToaster);
	}
	else{
		updateCredit(file,setToaster );
	}
    setShow(false);
  };

  const handleFileUpload = (info) => {
    if (info.fileList.length !== 0) {
      setFileData(info.file);
    }
  };

  const resetFile = () => {
    setFileData({});
  };

  return (
    <>
      <Button className="me-2 mb-1 btn btn-primary" onClick={handleShow}>
        Upload File
      </Button>
      <Modal show={show} fullscreen="sm-down" onHide={() => setShow(false)}>
        <Modal.Header>
          <Modal.Title>Modal</Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="grid gap-1 justify-items-center">
            <Upload
              accept=".csv"
              className="text-center"
              name="file"
              beforeUpload={(file) => beforeUpload(file)}
              onChange={handleFileUpload}
              maxCount={1}
              onRemove={resetFile}
            >
              <Button icon={<UploadOutlined />}>Add File</Button>
            </Upload>
            <Button
              className="w-max mt-2"
              loading={loading}
              onClick={uploadFile}
              type="primary"
            >
              Upload
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BulkUploadInVoices;
